<template>
    <Layout>
    <div class="max-w-4xl mx-auto text-center pt-8">
      <h1 class="text-3xl text-left pl-4 pb-4">Rooms on Rent</h1>
      <p class="text-left pl-4 pb-4">Shree Ghoghari Lohana Mahajan wadi has 2 rooms available on rent basis in Andheri. The rooms are built as per modern standards with basic necessities like T.V, A.C, attached bathrooms. Priority for bookings is given to people from outstation wishing to avail medical treatment.  For details on rates and booking you can mail us on secretary@sglm.in or contact us on +91 99872 40404 or +91 22 2628 3715.</p>
      <p class="text-left pl-4 pb-4">Inauguration of rooms was done by Shri Ummang by Thakkar (VP of Mahaparishad), Secretary Himanshu Thakkar & Solicitor Shri Mahendrabhai Ghelani on 13.11.2016</p>


      <h1 class="text-3xl text-left pl-4 pb-4 pt-4">Room Photos</h1>
      <div class="grid grid-cols-3 gap-4 pl-4">
        <div v-for="image in roomImages" :key="image.name" class="overflow-hidden">
          <img :src="image.url" :alt="`Conference Hall Image ${image.name}`" class="w-full h-auto px-4 py-8">
        </div>
      </div>
      </div>
    </Layout>
  </template>
  
  <script>

  import Layout from './../layouts/LayoutView.vue'
  import axiosInstance from '@/utils/axiosInstance';

  export default {
    components: {
      Layout
    },
    data() {
    return {
        roomImages: [],
    };
  },
  computed: {
  },
  async created() {
    try {
      const response = await axiosInstance.get('home-page?populate[serviceLinkList][populate]=linkMedia'); 
      var responseAttributes = response.data.data.attributes;
      this.roomImages = responseAttributes.serviceLinkList
        .filter(item => item.linkUrl === '/rooms-on-rent')
        .map(item => item.linkMedia.data[0].attributes);



    } catch (error) {
      console.error('Failed to fetch About Us Page:', error);
      
    }
  },
}
  </script>
    